module.exports = __webpack_public_path__ + "img/view-1.de52e4f4.svg";